import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { AgentService } from 'src/app/services/agent.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-lower-commission',
  templateUrl: './lower-commission.component.html',
  styleUrls: ['./lower-commission.component.css']
})
export class LowerCommissionComponent implements OnInit {
  
  isCompleted: boolean = false;
  lowerInfo: any;
  amount: number = 0;
  // глобальные параметры валюты приложения
  globalLocation = environment.globalLocation;
  globalCurrencyCode = environment.globalCurrencyCode;

  constructor(@Inject(MAT_DIALOG_DATA) public item: any,
    public snackBar: MatSnackBar,
    private translate: TranslateService,
    private agentSrv: AgentService
  ) { }

  ngOnInit(): void {
    this.getLowerCommission();
  }

  getLowerCommission() {
    this.isCompleted = false;
    this.amount = Number(this.item.service.amount);
    this.lowerInfo = [];
    this.agentSrv.lowers(this.item.service.serviceId).subscribe(
      data => {
        this.lowerInfo = data;
      },
      error => {
        let message = this.translate.instant('an-error-occurred-while-processing');
        this.openSnackBar(message, 'x');
      }
      ).add(() => { this.isCompleted = true });
  }


  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 5000,
    });
  }
}
